var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgChevDown(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 17,
    viewBox: "0 0 16 17",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M4.94 5.62109L8 8.67443L11.06 5.62109L12 6.56109L8 10.5611L4 6.56109L4.94 5.62109Z",
    fill: "#89A6FF"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgChevDown);
export default __webpack_public_path__ + "static/media/chev_down.7c9a0b2c471dc02166f560b2a63d9b7b.svg";
export { ForwardRef as ReactComponent };